// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__I8TzJ","spinner":"Loader_spinner__aTTB7","spin":"Loader_spin__o7R8I","text":"Loader_text__p4R1I"};